<template>
  <div
    v-if="canCallPatient"
    class="user-online-status"
  >
    <b-form-checkbox
      :checked="online"
      inline
      switch
      @change="onChange"
      class="user-online-status__switcher"
    ></b-form-checkbox>
    <div
      class="user-online-status__circle"
      :class="{
        'offline': !online
      }"
      :title="statusText"
    >
      <div
        class="user-online-status__circle-inner"
        :class="{
          'offline': !online
        }"
      ></div>
    </div>
    <span class="user-online-status__text">{{ statusText }}</span>
  </div>
</template>

<script>

import { computed, onMounted, onUnmounted, ref } from 'vue'
import { BFormCheckbox } from 'bootstrap-vue'
import { mixins } from '@/mixins';
import { entityPatientCall } from '@/libs/acl/entities'
import ability from '@/libs/acl/ability'
import store from '@/store'
import { addDataToLocalStorageByPrefix, getDataFromLocalStorageByPrefix } from '@/composables/localStorageHelper'
import appConstants from '@/constants/constants'
import { getId } from '@/composables/currentUser'
import { showFailedOperationToast, showSuccessOperationToast } from '@/composables/toast'

export default {
  name: 'UserOnlineStatus',
  components: {
    BFormCheckbox
  },
  setup() {
    const onlineStatus = computed(() => {
      const status = getDataFromLocalStorageByPrefix(appConstants.user.onlineStatus.IS_ONLINE_LOCAL_STORAGE_KEY)
      return status && status.online
    })
    const online = ref(!!onlineStatus.value)
    const statusText = computed(() => online.value ? 'Online' : 'Offline')
    const canCallPatient = computed(() => {
      return mixins.methods.getUserRoleType() === 'operator'
        && mixins.methods.isATEEnabled()
        && ability.can('read', entityPatientCall)
    })

    const onChange = async event => {
      online.value = event
      await store.dispatch('employee/changeOnlineStatus')
        .then(() => {
          showSuccessOperationToast('Ваш Online-статус успешно изменен')
          addDataToLocalStorageByPrefix(
            appConstants.user.onlineStatus.IS_ONLINE_LOCAL_STORAGE_KEY, {online: event}
          )
        })
        .catch(() => {
          showFailedOperationToast('Не удалось сменить ваш Online-статус')
          online.value = !online.value
        })
    }
    const onlineStatusChangeHandler = event => {
      const userID = getId()
      if (event.key === `${userID}-is-online`) {
        if (event.newValue) {
          const status = JSON.parse(event.newValue)
          online.value = status && !!status.online
        } else {
          online.value = false
        }
      }
    }

    onMounted(() => window.addEventListener('storage', onlineStatusChangeHandler))
    onUnmounted(() => window.removeEventListener('storage', onlineStatusChangeHandler))

    return {
      online,
      statusText,
      canCallPatient,

      onChange
    }
  }
}
</script>

<style lang='scss' scoped>

@import '@/assets/scss/variables/variables';

.user-online-status {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: .95rem;

  &__switcher {
    margin-top: -3.5px;
    margin-right: .25rem;
  }

  &__circle {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    width: 20px;
    height: 20px;
    background: #28c76f1f;
    margin-right: .5rem;

    &.offline {
      background: #ea54551f;
    }
  }

  &__circle-inner {
    border-radius: 5px;
    width: 10px;
    height: 10px;
    background: $success;
    opacity: .7;

    &.offline {
      background: $danger;
    }
  }

  &__text {
    font-weight: 600;
  }

  @media screen and (max-width: 460px) {
    margin-right: 0;

    &__text {
      display: none;
    }
  }
}

</style>
